export default __webpack_public_path__ + "static/media/icon_park_outline_transaction_new.52039526.svg";